export default __webpack_public_path__ + "locales/uk-UA/People.json?hash=f18ee3ec69a50a3c7b06ad5435e7fc5c";